import { CacheKeyNames } from '@core/constants/utility/cache-key-names';
import { useCache } from '@core/utils/context/cache-context';
import { useCachedFetch } from '@core/utils/hooks/use-cached-fetch';
import { useEffect, useMemo } from 'preact/hooks';

export function useHistoryData(recordId, requestParams) {
    const endpoint = `/attestation-records/${recordId}/history`;

    const { setKey } = useCache();

    const { data, isLoading, error } = useCachedFetch(endpoint, requestParams, {
        enabled: true,
        keepPreviousData: true,
    });

    useEffect(() => {
        setKey(CacheKeyNames.attestationHistoryTable, { cacheKey: [endpoint, requestParams] });
    }, [endpoint, requestParams]);

    const tableData = useMemo(() => {
        const items = data?.items || [];
        const total = data?.total || 0;

        return { rows: items, total, isLoading };
    }, [data, isLoading]);

    return { data, error, isLoading, tableData };
}
